import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { ModulesEnum } from '../../models/modules-enum.model';
import { ActionsEnum } from '../../models/action-enum.model';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[hasAuthorization]'
})
export class HasAuthorizationDirective {
    private action: any;
    private permission: any;
    private actionsList: any;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authService: AuthenticationService
    ) { }

    @Input()
    set hasAuthorization(val: any) {
        this.permission = ModulesEnum[val[0]];
        this.action = ActionsEnum[val[1]];
        this.actionsList = val[2];
        this.updateView();
    }

    /**
     * Controla se o elemento HTML deve ser exibido de acordo com a permissão e ação necessária para exibir.
     */
    private updateView() {
        this.viewContainer.clear();
        this.validatePermissionAction();
    }

    /**
     * Valida se o usuário logado possuí a permissão e ação necessária para acessar o conteúdo.
     */
    private validatePermissionAction() {
        this.authService.IdentityPermissionAction.subscribe(permissaoAcao => {
            if (permissaoAcao.some(x => this.validatePermission(x.Permissao.IdPermissao) && this.validateAction(x.Acao.IdAcao))) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }

    /**
     * Valida se o usuário logado possuí a permissão necessária para acessar o conteúdo.
     * @param idPermissao ID da permissão do usuário logado.
     */
    private validatePermission(idPermissao: any): boolean {
        return idPermissao === this.permission;
    }

    /**
     * Valida se o usuário logado possuí a ação necessária para acessar o conteúdo.
     * @param idAcao ID da ação do usuário logado.
     */
    private validateAction(idAcao: any): boolean {
        return (idAcao === this.action || this.action === 0 && this.validateActionsList());
    }

    /**
 * Valida se a lista de acões já está populada
 */
    private validateActionsList(): boolean {
        if (this.actionsList) {
            return this.actionsList.some(x => x === this.action);
        }

        return true;
    }
}
